import { createFileRoute } from "@tanstack/react-router";
import { EsPlaceholder, esHead } from "@/knowmeno/marketing/EsPlaceholder";

export const Route = createFileRoute("/es/aviso-legal")({
  head: () => esHead({
    path: "/aviso-legal",
    title: "Aviso legal y descargo médico | SepaMeno",
    description: "Aviso legal de SepaMeno: no es un dispositivo médico ni reemplaza a tu doctora.",
    englishPath: "/disclaimer",
  }),
  component: () => (
    <EsPlaceholder
      title="Aviso legal"
      subtitle="SepaMeno es una herramienta de bienestar — no un dispositivo médico. Versión completa en español próximamente."
      englishHref="https://knowmeno.com/disclaimer"
    />
  ),
});
